<template>
  <div id="app">
    <component :is="layout">
      <router-view/>
    </component>
    <transition name="fade">
      <div id="loading" v-if="spin.loading">
        <spinner
          :message="spin.message"
          :line-fg-color="spin.hex"
          text-fg-color="#585858"
          :speed="1"
          size="huge"></spinner>
      </div>
    </transition>
    <div id="global-notifications-overlay" v-if="notifications.length > 0">
      <div id="global-notifications-list">
        <transition-group name="notifications-list">
          <div
            v-for="(note, index) in notifications" :key="index"
            :class="note.classes">
            {{note.message}}
            <div class="clearfix"></div>
            <button class="btn btn-sm close" @click="closeNotification(index)">OK</button>
          </div>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner'
export default {
  components: {
    spinner: Spinner
  },
  data () {
    return {
      spin: {
        loading: false,
        message: '',
        hex: ''
      },
      spinColors: {
        admin: '#0033ab',
        client: '#2a2a2a'
      },
      showNotification: false,
      note: '',
      notifications: [],
      classesMap: {
        danger: 'notification-danger',
        info: 'notification-info'
      },
      defaultClasses: 'global-notification text-center',
      notificationClasses: 'info',
      timeoutId: null
    }
  },
  computed: {
    layout () {
      return (this.$route.meta.layout || 'default') + '-layout'
    }
  },
  created () {
    this.$bus.on('notify', this.notify)
    this.$bus.on('global-load', this.load)
  },
  beforeDestroy () {
    this.$bus.off('notify', this.notify)
    this.$bus.off('global-load', this.load)
  },
  methods: {
    notify (options) {
      let note = { message: options.message }
      // const time = options.time || 5000
      note.classes = this.defaultClasses + ' ' + (this.classesMap[options.type] || 'notification-info')
      this.notifications.push(note)
      // this.timeoutId = setTimeout(() => {
      //   this.notifications.shift()
      // }, time)
    },
    closeNotification (idx) {
      this.notifications.splice(idx, 1)
    },
    load (options) {
      if (options.load) {
        this.spin.message = options.message
        this.spin.hex = this.spinColors[options.env] || '#2196f3' // the default is the color of the vue-simple-spinner defaul
        this.spin.loading = true
      } else {
        this.spin.message = ''
        this.spin.hex = ''
        this.spin.loading = false
      }
    }
  }
}
</script>

<style>
.subhead-bg{
  background-image:url("./assets/images/subhead-bg.jpg");
  color:#FFF;
  text-align: center;
  padding:30px 15px;
}

.blue-subhead-bg{
  background-image:url("./assets/images/blue-banner.jpg");
  color:#FFF;
  text-align: center;
  padding:30px 15px;
}

.grey-subhead-bg{
  background-image:url("./assets/images/grey-banner.jpg");
  color:#FFF;
  text-align: center;
  padding:30px 15px;
}
</style>

<style scoped>
#loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

#global-notifications-overlay {
  position: fixed;
  top: 10px;
  left: 30%;
  width: 40%;
  min-height: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

#global-notifications-list {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.global-notification {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  border: 1px solid black;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 5px;
  width: 100%;
  min-height: 90px;
  overflow-wrap: break-word;
  background-color: white;
  transition: all 1s;
}

.global-notification .btn:focus {
  outline: unset;
  outline-offset: unset;
}

.notification-info {
  border: 1px solid rgba(0, 51, 171,.60);
  -webkit-box-shadow: 0px 0px 5px rgba(0, 51, 171,0.75);
  box-shadow: 0px 0px 5px rgba(0, 51, 171,0.75);
}

.notification-danger {
  border: 1px solid rgba(171, 0, 0,.60);
  -webkit-box-shadow: 0px 0px 5px rgba(171, 0, 0,0.75);
  box-shadow: 0px 0px 5px rgba(171, 0, 0,0.75);
}

/* .notifications-list-enter {
  opacity: 0;
  transform: translateY(30px);
} */

.notifications-list-enter-active, .notifications-list-leave-active {
  /* opacity: 1; */
  transform: all 1s;
}

.notifications-list-leave-to, .notifications-list-enter
/* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

/* .notifications-list-leave-active {
  position: absolute;
} */

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
